module.exports = __webpack_public_path__ + "img/HelpingHand-01.95665a19.svg";